import React, { useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

// To Do: Redirecting the solution from the Navbar to this solution section 

const Solutions = () => {
    const [activeSolution, setActiveSolution] = useState(null);
    const [activeTab, setActiveTab] = useState(null);

    const solutions = [
        {
            category: "Advanced Software Solutions & Digital Transformation",
            items: [
                // { image: "AdvancedComputing&CloudEdgeTechnologies.svg", title: "Advanced Computing & Cloud/Edge Technologies" },
                { image: "ArtificialIntelligence(AI)&MachineLearning(ML).svg", title: "AI & Machine Learning" },
                { image: "Cybersecurity&DataPrivacy.svg", title: "Cybersecurity & Data Privacy" },
                { image: "AIAgents&ConversationalAI.svg", title: "AI Agents & Conversational AI" },
                // { image: "DataCenters&CloudInfrastructure.svg", title: "Data Centers & Cloud Infrastructure" },
                // { image: "AIwithQuantumComputing.svg", title: "AI with Quantum Computing" }
            ]
        },
        {
            category: "Revolutionizing Digital Presence & Metaverse Experiences",
            items: [
                { image: "AdvancedWebsiteDevelopment.svg", title: "Advanced Website Development" },
                { image: "Metaverse&ImmersiveEnvironments.svg", title: "Metaverse & Immersive Environments" },
                // { image: "Human-MachineInterfaces(HMI).svg", title: "Human-Machine Interfaces (HMI)" },
                // { image: "UXUIDesign&Human-CenteredInterfaces.svg", title: "UX/UI Design & Human-Centered Interfaces" }
                { image: "UXUIDesign&Human-CenteredInterfaces.svg", title: "UX/UI Design" }
            ]
        },
        {
            category: "Empowering Businesses with Next-Generation Corporate Solutions",
            items: [
                { image: "CustomizedWorkflowDevelopment.svg", title: "Customized Workflow Development" },
                // { image: "IntegratedCorporateSolutions.svg", title: "Integrated Corporate Solutions" },
                // { image: "InnovativeCommunication&NetworkingTechnologies.svg", title: "Innovative Communication & Networking Technologies" },
                { image: "AI-PoweredCustomerSupportSystems(AIAgents).svg", title: "AI-Powered Customer Support Systems (AI Agents)" }
            ]
        },
        // {
        //     category: "Merging Technology with Social Impact",
        //     items: [
        //         { image: "SmartCity&IoTInnovations.svg", title: "Smart City & IoT Innovations" },
        //         { image: "InclusiveDigitalTransformation.svg", title: "Inclusive Digital Transformation" },
        //         { image: "Eco-FriendlyandCleanEnergyDataSolutions.svg", title: "Eco-Friendly & Clean Energy Data Solutions" }
        //     ]
        // },
        {
            category: "Future Vision: Driving Breakthroughs & Disruptive Innovation",
            items: [
                { image: "QuantumComputing&Beyond.svg", title: "Quantum Computing & Beyond" },
                { image: "Blockchain&DigitalIdentity.svg", title: "Blockchain & Digital Identity" },
                { image: "Automation&Robotics.svg", title: "Automation & Robotics" },
                { image: "AutonomousVehicles&AI-AssistedMobility.svg", title: "Autonomous Vehicles & AI-Assisted Mobility" }
            ]
        }
    ];

    // Change the constant name
    const solutionContent = {
        "Advanced Software Solutions & Digital Transformation": {
            "Overview and Core Offering": "Our approach centers on developing intelligent software systems that revolutionize your operational backbone. We deploy digital twin simulations, cloud and edge infrastructure, and cutting-edge AI agents that handle critical functions—allowing businesses to reengineer processes with high precision. This solution empowers you to automate repetitive tasks, integrate complex systems seamlessly, and transform legacy infrastructure into dynamic, data-driven environments.",
            "The Business Impact": "• By modernizing your software foundation, organizations experience streamlined workflows and reduced response times for critical decision-making.\n\n• The integration of these technologies leads to increased efficiency, lower operational costs, and enhanced competitiveness in rapidly evolving markets.\n\n• Strategic insights drawn from real-time analytics pave the way for continuous improvement.",
            "Implementation Methodology": "• We begin with a deep assessment of your current digital infrastructure to pinpoint automation and integration opportunities.\n\n• Our team then architecturally designs a solution that leverages the latest cloud and AI technologies, ensuring a scalable and secure environment.\n\n• Continuous monitoring and iterative enhancement guarantee that the system adapts to evolving business needs.",
            "Our Distinct Advantage": "Our proven track record in deploying digital transformation solutions means our clients enjoy measurable gains in efficiency and innovation. We combine technical expertise with a customer-centric approach, ensuring that every system we build is designed not just to perform, but to grow alongside your business.",
            "A Call for Partnership": "We believe that by modernizing your software landscape together, we can overcome the challenges of today while setting the stage for a future built on technology-driven success. We invite you to join us on this transformative journey."
        },
        "Revolutionizing Digital Presence & Metaverse Experiences": {
            "Overview and Core Offering": "In this approach, we redefine how your brand interacts with its audience by creating digital landscapes that captivate and engage. Our services include state-of-the-art UX/UI design, innovative website and mobile development, and immersive environments powered by AR/VR and metaverse technologies. These solutions craft experiences that are not only visually impressive but also deeply responsive to user behavior.",
            "The Business Impact": "• Immersive digital experiences result in higher customer engagement and longer interaction times.\n\n• A well-designed digital presence enhances brand perception, responsiveness, and loyalty.\n\n• Integrated digital touchpoints across various platforms ensure a cohesive and memorable customer journey.",
            "Implementation Methodology": "• We conduct comprehensive user research and market analysis to transform insights into intuitive design.\n\n• Prototypes and dynamic interfaces are iteratively developed, combined with intelligent conversational systems for natural interaction.\n\n• The final product is rigorously tested across devices and platforms to guarantee smooth performance and rich, interactive experiences.",
            "Our Distinct Advantage": "Our creative and technical teams excel in merging aesthetics with functionality. Clients choose us for our capability to transform digital visions into reality, offering solutions that not only meet current demands but also set trends for future digital engagement.",
            "A Call for Partnership": "Join us in crafting digital experiences that stand out. Together, we can innovate the way users interact with your brand and build a network of loyal customers who are excited by every digital encounter."
        },
        "Empowering Businesses with Next-Generation Corporate Solutions": {
            "Overview and Core Offering": "This approach is tailored for organizations seeking comprehensive enterprise solutions. We consolidate essential business functions into integrated ERP/CRM platforms, enriched by enterprise-level business intelligence and intelligent workflow automation. This unification fosters internal synergy, transforming disparate systems into a coherent, dynamic operational ecosystem.",
            "The Business Impact": "• Streamlined operations result in real-time data visibility and well-informed strategic decisions.\n\n• Automation of routine processes leads to significant cost reductions and resource reallocation for higher-value tasks.\n\n• Enhanced data integration strengthens inter-departmental communication and corporate agility.",
            "Implementation Methodology": "• We initiate our process with a detailed diagnostic review of your existing systems and processes.\n\n• Customized integration strategies are then developed, embedding automation and intelligent workflow orchestration tailored to your business model.\n\n• Regular updates and performance evaluations help fine-tune the system into a robust and future-ready enterprise resource.",
            "Our Distinct Advantage": "Our expertise in unifying complex systems ensures a smooth transition to a more agile, data-centric operation. Clients rely on our holistic approach because we not only implement technology but also drive cultural transformation within their organizations.",
            "A Call for Partnership": "Let's revolutionize your internal operations by creating a system that evolves with your business. Together, we can build a future where your enterprise operates seamlessly and efficiently, paving the way for ongoing success."
        },
        "Merging Technology with Social Impact": {
            "Overview and Core Offering": "This approach integrates cutting-edge technology with socially responsible initiatives. We develop smart city solutions, renewable energy management platforms, and community-centric digital tools that enhance quality of life and promote sustainability. Our solutions extend beyond business gains, aiming to create positive social change in urban living, environmental stewardship, and public services.",
            "The Business Impact": "• By leveraging IoT and analytics in urban and environmental settings, these solutions drive both operational efficiency and sustainable growth.\n\n• Enhanced public services and smart infrastructures reduce waste and improve resource management on a community-wide scale.\n\n• Improved transparency and civic engagement foster trust and social well-being.",
            "Implementation Methodology": "• We begin with a strategic assessment of community challenges and sustainability goals.\n\n• Collaborative custom-build systems are then developed, integrating sensor technologies, blockchain for security, and data analytics to turn insights into actionable strategies.\n\n• Our deployment ensures that the impact is measurable, with continuous monitoring for improvements and scale-up.",
            "Our Distinct Advantage": "Our commitment to merging technology with social good is evident in our track record of successful projects that yield both environmental and economic benefits. Clients appreciate our ability to deliver solutions that not only drive efficiency but also contribute to the public good.",
            "A Call for Partnership": "Let's work side by side to create technological solutions that benefit both your organization and society at large. With our shared vision, we can drive progress that makes a lasting difference in the communities we serve."
        },
        "Future Vision: Driving Breakthroughs & Disruptive Innovation": {
            "Overview and Core Offering": "Our forward-looking approach is dedicated to harnessing emerging technologies such as autonomous systems, quantum computing, and decentralized digital platforms. We build systems that push the limits—integrating AI with quantum processes, developing next-generation blockchain networks, and exploring breakthrough applications across varied industries.",
            "The Business Impact": "• Such transformative solutions open up new market opportunities and redefine industry standards.\n\n• Enhanced processing speeds and improved algorithmic precision lead to significant competitive advantages.\n\n• Organizations positioning themselves at the forefront of these innovations enjoy increased market leadership and innovation potential.",
            "Implementation Methodology": "• We continually invest in research and development and collaborate with technology pioneers to integrate the latest advances into our solutions.\n\n• Hybrid models combining classical and quantum computing techniques are deployed to address complex problems.\n\n• Pilot projects and iterative testing ensure that these advanced systems are not only cutting edge but also robust and scalable when applied across various applications.",
            "Our Distinct Advantage": "Our relentless pursuit of breakthrough technologies and our ability to merge emerging capabilities with practical applications set us apart. Clients choose us because we offer a glimpse into the future, providing tools that are not only innovative but also finely tuned to today's market demands.",
            "A Call for Partnership": "Join our journey into the next technological frontier. By embracing disruptive breakthroughs together, we can transform challenges into opportunities and lead the way toward a more innovative, secure, and efficient future."
        }
    };

    const handleSolutionClick = (title) => {
        setActiveSolution(activeSolution === title ? null : title);
        setActiveTab(null);
    };

    const handleTabClick = (tab) => {
        setActiveTab(activeTab === tab ? null : tab);
    };

    // First, update the constant for button labels
    const tabLabels = [
        "Overview and Core Offering",
        "The Business Impact",
        "Implementation Methodology",
        "Our Distinct Advantage",
        "A Call for Partnership"
    ];

    // Add this helper function to format bullet points
    const formatContent = (content) => {
        if (!content) return null;

        // Check if content starts with bullet points
        if (content.startsWith('•')) {
            // Split by bullet points and create a list
            return (
                <ul className="list-none space-y-4">
                    {content.split('•').filter(Boolean).map((item, index) => (
                        <li key={index} className="flex items-start">
                            <span className="mr-2 text-orange-500">•</span>
                            <span>{item.trim()}</span>
                        </li>
                    ))}
                </ul>
            );
        }

        // Return regular text if no bullets
        return <p>{content}</p>;
    };

    // Update the accordion content section in renderAccordionContent
    const renderAccordionContent = (solution) => {
        const content = solutionContent[solution];
        if (!content) return null;

        return (
            <div className="col-span-full bg-gray-900 p-6 rounded-lg mt-4 shadow-lg">
                <div className="container mx-auto">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-2xl font-bold text-white">{solution}</h2>
                        <button
                            onClick={() => setActiveSolution(null)}
                            className="text-gray-400 hover:text-white"
                        >
                            ✕
                        </button>
                    </div>

                    <div className="flex gap-6">
                        {/* Left side - Vertical buttons */}
                        <div className="flex flex-col gap-2 w-1/4">
                            {tabLabels.map((tab) => (
                                <button
                                    key={tab}
                                    onClick={() => handleTabClick(tab)}
                                    className={`px-4 py-3 rounded-lg transition-colors duration-300 text-left text-sm lg:text-base ${activeTab === tab
                                        ? 'bg-red-700 text-white'
                                        : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                                        }`}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>

                        {/* Right side - Content panel */}
                        {activeTab && (
                            <div className="flex-1 text-lg leading-relaxed p-6 bg-gray-800 rounded-lg">
                                <div className="space-y-4">
                                    {content[activeTab]}
                                    {activeTab === "A Call for Partnership" && (
                                        <div className="flex justify-end mt-6">
                                            <a
                                                href="/contact"
                                                className="bg-red-700 hover:bg-red-800 font-bold py-3 px-8 rounded-lg transition-colors duration-300"
                                            >
                                                Contact Us
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    // Update section ID and comments
    return (
        <section id="solutions" className="py-4 sm:py-4 md:py-16 lg:py-16 px-2">
            {/* <AnimatedSection> */}
            <div className="container mx-auto px-6 lg:px-20">
                <div className="w-full p-4">
                    <p className="text-2xl text-left md:text-justify lg:text-justify mb-12">
                        At Decimic Inc., we harness the power of emerging, critical, and cutting-edge technologies to
                        transform the digital landscape. We are a forward-thinking IT company specializing in software
                        development, advanced website development, immersive metaverse experiences, business and corporate
                        solutions, and optimized workflow development. Leveraging breakthroughs in artificial intelligence,
                        machine learning, advanced computing, cybersecurity, IoT, and blockchain, we create transformative
                        user experiences that redefine digital engagement. Our holistic approach drives digital
                        transformation and solve key social challenges while fueling sustainable business growth.
                    </p>

                    {/* Solutions Grid with Categories */}
                    <div className="space-y-12">
                        {solutions.map((category, categoryIndex) => (
                            <CategorySection
                                key={categoryIndex}
                                category={category}
                                categoryIndex={categoryIndex}
                                activeSolution={activeSolution}
                                renderAccordionContent={renderAccordionContent}
                                handleSolutionClick={handleSolutionClick}
                                solutionContent={solutionContent} // Add this prop
                                formatContent={formatContent}  // Add this prop
                            />
                        ))}
                    </div>
                </div>
            </div>
            {/* </AnimatedSection> */}
        </section>
    );
};

// Update the CategorySection props to include formatContent
const CategorySection = ({
    category,
    categoryIndex,
    activeSolution,
    renderAccordionContent,
    handleSolutionClick,
    solutionContent,
    formatContent  // Add this prop
}) => {
    const [ref, inView] = useInView({
        threshold: 0.2,
        triggerOnce: false
    });

    // Add state for active tab with a default value
    const [localActiveTab, setLocalActiveTab] = useState("Overview and Core Offering");

    const tabLabels = [
        "Overview and Core Offering",
        "The Business Impact",
        "Implementation Methodology",
        "Our Distinct Advantage",
        "A Call for Partnership"
    ];

    return (
        <div className="mb-12">
            <motion.div
                ref={ref}
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: categoryIndex * 0.2 }}
                className="w-full bg-gray-900 mb-8"
            >
                <motion.h1
                    className="text-3xl md:text-4xl lg:text-5xl font-bold text-center py-4 border-b-2 border-orange-700"
                    initial={{ scale: 0.9 }}
                    animate={inView ? { scale: 1 } : { scale: 0.9 }}
                    transition={{ duration: 0.4, ease: "easeInOut", delay: (categoryIndex * 0.2) + 0.3 }}
                >
                    {category.category}
                </motion.h1>

                {/* Add the vertical buttons and content panel below the title */}
                <div className="flex flex-col lg:flex-row gap-6 p-6">
                    {/* Top (mobile) / Left side (desktop) - Buttons */}
                    <div className="flex flex-wrap lg:flex-col gap-2 w-full lg:w-1/4">
                        {tabLabels.map((tab) => (
                            <button
                                key={tab}
                                onClick={() => setLocalActiveTab(tab)}
                                className={`px-4 py-3 rounded-lg transition-colors duration-300 text-sm lg:text-base text-center lg:text-left ${localActiveTab === tab
                                        ? 'bg-orange-500 text-white'
                                        : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                                    }`}
                                style={{ flex: '1 1 auto', minWidth: '100px' }} // prevent squishing
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                    {/* Right side - Content panel */}
                    <div className="flex-1 text-lg leading-relaxed p-6 bg-gray-800 rounded-lg">
                        <div className="space-y-4">
                            {solutionContent[category.category] &&
                                formatContent(solutionContent[category.category][localActiveTab])}
                            {localActiveTab === "A Call for Partnership" && (
                                <div className="flex justify-end mt-6">
                                    <a
                                        href="/contact"
                                        className="text-white bg-orange-500 hover:bg-orange-600 font-bold py-3 px-8 rounded-lg transition-colors duration-300"
                                    >
                                        Contact Us
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </motion.div>

            {/* Rest of the grid layout for solution items */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative">
                {category.items.map((solution, index) => {
                    const rowNumber = Math.floor(index / 3);
                    const isLastInRow = (index + 1) % 3 === 0 || index === category.items.length - 1;
                    const startIdx = rowNumber * 3;
                    const itemsInCurrentRow = category.items.slice(startIdx, startIdx + 3);

                    return (
                        <React.Fragment key={index}>
                            <div className="relative group">
                                <div
                                    onClick={() => handleSolutionClick(solution.title)}
                                    className="cursor-pointer"
                                >
                                    <div className="overflow-hidden rounded-lg">
                                        <img
                                            src={`/images/solutions/${solution.image}`}
                                            alt={solution.title}
                                            className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                                        />
                                    </div>
                                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4">
                                        <div className="flex items-center justify-between text-white">
                                            <h3 className="text-xl font-bold">{solution.title}</h3>
                                            {/* <span className="transform group-hover:translate-x-2 transition-transform duration-300">
                                                →
                                            </span> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {isLastInRow && activeSolution &&
                                itemsInCurrentRow.some(ind => ind.title === activeSolution) &&
                                renderAccordionContent(activeSolution)}
                        </React.Fragment>
                    );
                })}
                {activeSolution &&
                    category.items.some(ind => ind.title === activeSolution) &&
                    !category.items.slice(-3).some(ind => ind.title === activeSolution) &&
                    renderAccordionContent(activeSolution)}
            </div>
        </div>
    );
};

export default Solutions;
